import { Pipe, PipeTransform } from '@angular/core';
import { SmsAttemptStatus } from '@workspace/data-types';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

@Pipe({
  name: 'smsAttemptStatusDisplay',
})
export class SmsAttemptStatusDisplayPipe implements PipeTransform {
  transform(value: SmsAttemptStatus): string {
    return smsAttemptStatusDisplayTransform(value);
  }
}

export function smsAttemptStatusDisplayTransform(value: SmsAttemptStatus) {
  return CoreNiceLabelUtils.smsAttemptStatus(value);
}
